import {
  ConfigSelectors,
  HistogramSelectors,
  ProgressSelectors,
  renderStringToReact,
  useTranslation,
} from '@web_opxp/features';
import { FC } from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../../base/constants';
import HintPopup from '../../components/HintPopup/HintPopup';
import { SessionSelectors } from '../../session';
import { IState } from '../../store/state';
import PredictorWidget from './PredictorWidget';

export interface IHighscoreComparisonProps {
  comparison: number;
  loading: boolean;
}

export const HighscoreComparisonFC: FC<IHighscoreComparisonProps> = ({ comparison, loading }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <PredictorWidget title={SKELETON_DUMMYTEXT} description={SKELETON_DUMMYTEXT} customClass={SKELETON_CLASSNAME} />
    );
  }
  const percentage = Math.round(comparison);
  if (percentage < 50) {
    // do not show when percentage is less than 50%, see BW-4302 for details
    return null;
  }
  const title = t('opxp.training:SuccessPredictor.Comparison.Title', { percentage });
  const description = t('opxp.training:SuccessPredictor.Comparison.Description');
  const hintTitle = t('SuccessPredictor.Comparison.HintTitle');
  const hintContent = t('SuccessPredictor.Comparison.HintHtml');
  const hint = renderStringToReact(hintContent);

  return (
    <PredictorWidget title={title} description={description}>
      <HintPopup title={hintTitle}>{hint}</HintPopup>
    </PredictorWidget>
  );
};

export const mapStateToProps = (state: IState) => {
  let comparison = 0;
  const workoutId = SessionSelectors.getActiveWorkoutId(state);
  // when session is loading workoutId will be 0
  const loading = workoutId === 0;
  if (!loading) {
    const siblings = ConfigSelectors.getWorkoutIdsOfCategoryGroup(state, workoutId);
    const highscore = ProgressSelectors.getHighscoreResultWithSiblings(state, siblings);
    const score = highscore ?? 0;
    comparison = HistogramSelectors.getWorkoutComparison(state, workoutId, score);
  }
  return {
    comparison,
    loading,
  };
};

const HighscoreComparison = connect(mapStateToProps)(HighscoreComparisonFC);
export default HighscoreComparison;
